import { createContext, useContext } from 'react'
import { User } from 'xund-auth'

export const UserContext = createContext<{ user: User | null }>({ user: null })

export const useUserContext = () => useContext(UserContext)
